const ALPHA = "234567abcdefghijklmnopqrstuvwxyz";
const MAX_MICROS = 2 ** 53; // exclusive; matches the 53-bit TID timestamp field

/** atproto TID layout: 0 | 53-bit µs | 10-bit clkid, base32-sortable, 13 chars. */
export function encodeTid(micros: number, clkid: number): string {
  if (!Number.isInteger(micros) || micros < 0 || micros >= MAX_MICROS)
    throw new RangeError(`tid micros out of range: ${micros}`);
  if (!Number.isInteger(clkid) || clkid < 0 || clkid > 0x3ff)
    throw new RangeError(`tid clkid out of range: ${clkid}`);
  let v = (BigInt(micros) << 10n) | BigInt(clkid);
  let out = "";
  for (let i = 12; i >= 0; i--) out += ALPHA[Number((v >> BigInt(i * 5)) & 31n)];
  return out;
}

/** Strictly monotonic mint: sequence counter ticks within a frozen timestamp (ADR-13). */
export class TidMinter {
  private last = -1;
  constructor(private readonly clkid: number) {}
  mint(nowMicros: number): string {
    this.last = Math.max(nowMicros, this.last + 1);
    return encodeTid(this.last, this.clkid);
  }
}
